import _taggedTemplateLiteral from "/vercel/workpath0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";
import _classCallCheck from "/vercel/workpath0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/workpath0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _get from "/vercel/workpath0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _getPrototypeOf from "/vercel/workpath0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/vercel/workpath0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/vercel/workpath0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n        :host {\n          display: inline-block;\n          position: relative;\n          line-height: 1;\n          padding: 3px;\n        }\n        img {\n          display: block;\n          box-sizing: border-box;\n          max-width: 100%;\n          max-height: 100%;\n        }\n        path {\n          stroke-width: 1;\n        }\n      "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    <img src=\"", "\">\n    <div id=\"overlay\"><svg></svg></div>\n    "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

import { WiredBase, BaseCSS } from 'wired-lib/lib/wired-base';
import { rectangle, line } from 'wired-lib';
import { customElement, property, css, html } from 'lit-element';
var EMPTY_IMAGE = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=';

var WiredImage = /*#__PURE__*/function (_WiredBase) {
  _inherits(WiredImage, _WiredBase);

  var _super = _createSuper(WiredImage);

  function WiredImage() {
    var _this;

    _classCallCheck(this, WiredImage);

    _this = _super.call(this);
    _this.elevation = 1;
    _this.src = EMPTY_IMAGE;

    if (window.ResizeObserver) {
      _this.resizeObserver = new window.ResizeObserver(function () {
        if (_this.svg) {
          _this.wiredRender();
        }
      });
    }

    return _this;
  }

  _createClass(WiredImage, [{
    key: "render",
    value: function render() {
      return html(_templateObject(), this.src);
    }
  }, {
    key: "updated",
    value: function updated() {
      _get(_getPrototypeOf(WiredImage.prototype), "updated", this).call(this);

      this.attachResizeListener();
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      this.detachResizeListener();
    }
  }, {
    key: "attachResizeListener",
    value: function attachResizeListener() {
      var _this2 = this;

      if (this.resizeObserver && this.resizeObserver.observe) {
        this.resizeObserver.observe(this);
      } else if (!this.windowResizeHandler) {
        this.windowResizeHandler = function () {
          return _this2.wiredRender();
        };

        window.addEventListener('resize', this.windowResizeHandler, {
          passive: true
        });
      }
    }
  }, {
    key: "detachResizeListener",
    value: function detachResizeListener() {
      if (this.resizeObserver && this.resizeObserver.unobserve) {
        this.resizeObserver.unobserve(this);
      }

      if (this.windowResizeHandler) {
        window.removeEventListener('resize', this.windowResizeHandler);
      }
    }
  }, {
    key: "canvasSize",
    value: function canvasSize() {
      var s = this.getBoundingClientRect();
      var elev = Math.min(Math.max(1, this.elevation), 5);
      var w = s.width + (elev - 1) * 2;
      var h = s.height + (elev - 1) * 2;
      return [w, h];
    }
  }, {
    key: "draw",
    value: function draw(svg, size) {
      var elev = Math.min(Math.max(1, this.elevation), 5);
      var s = {
        width: size[0] - (elev - 1) * 2,
        height: size[1] - (elev - 1) * 2
      };
      rectangle(svg, 2, 2, s.width - 4, s.height - 4, this.seed);

      for (var i = 1; i < elev; i++) {
        line(svg, i * 2, s.height - 4 + i * 2, s.width - 4 + i * 2, s.height - 4 + i * 2, this.seed).style.opacity = "".concat((85 - i * 10) / 100);
        line(svg, s.width - 4 + i * 2, s.height - 4 + i * 2, s.width - 4 + i * 2, i * 2, this.seed).style.opacity = "".concat((85 - i * 10) / 100);
        line(svg, i * 2, s.height - 4 + i * 2, s.width - 4 + i * 2, s.height - 4 + i * 2, this.seed).style.opacity = "".concat((85 - i * 10) / 100);
        line(svg, s.width - 4 + i * 2, s.height - 4 + i * 2, s.width - 4 + i * 2, i * 2, this.seed).style.opacity = "".concat((85 - i * 10) / 100);
      }
    }
  }], [{
    key: "styles",
    get: function get() {
      return [BaseCSS, css(_templateObject2())];
    }
  }]);

  return WiredImage;
}(WiredBase);

__decorate([property({
  type: Number
}), __metadata("design:type", Object)], WiredImage.prototype, "elevation", void 0);

__decorate([property({
  type: String
}), __metadata("design:type", String)], WiredImage.prototype, "src", void 0);

WiredImage = __decorate([customElement('wired-image'), __metadata("design:paramtypes", [])], WiredImage);
export { WiredImage };